import { LabMDM } from './lab';
import { Machine } from './machine';
import { OperetionHistoryDTO } from './operationHistory';

export class InboundFileProcessing{
    _id: string;

    name:string;

    lab:LabMDM;

    handler:string;
    
    location:string;

    active:boolean;

    autoProcessing:boolean;

    machine: Machine;

    regexRunID:string;

    version : number;

    creationDate: Date;

    lastModifiedDate: Date;

    history:OperetionHistoryDTO[];
}